import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";
import Grid from "@mui/material/Unstable_Grid2";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import {
  Box,
  Button,
  FormControlLabel,
  Link,
  Modal,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import DatePicker from "../../../../../Supporting files/DatePicker/DatePicker";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import CancelIcon from "@mui/icons-material/Cancel";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import {
  validateEmail,
  validateMobileNumber,
} from "../../../../../Supporting files/HelpingFunction";
import "../../../../../formLayout.scss";
import SlidingPanel from "react-sliding-side-panel";
import ListViewTable from "../../TaskManagement/CreateTask/ListViewTable";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import PostAddIcon from "@mui/icons-material/PostAdd";
import PostQueryForm from "../../../../../Components/Common/PostQuerySP/PostQueryForm";
import BulkUploadForm from "../../../../../Components/Common/BulkUploadFormSP/BulkUploadForm";
import RKTextFieldDisable from "../../../../../Supporting files/RKTextFieldDisable/RKTextFieldDisable";
import UGTable from "../../../../../Supporting files/UGTable/UGTable";
import Attachment from "../../../../../Components/Broker/Attachment/Attachment";
import TasksSection from "../../../../../Components/Broker/TasksSection/TasksSection";
import NotesSection from "../../../../../Components/Broker/NotesSection/NotesSection";
function ContactDetail() {
  const navigate = useNavigate();
  const [tableData, setTableData] = React.useState([
    {
      title: "Started",
      title_class: "green",
      data: [
        {
          open_status: false,
          title: "Follow Up",
          status: "started",
          due_date: "31 Dec",
          priority: "High",
          priority_class: "high",
          linked_to: "Quotes-QT25",
          assignee: ["U", "R"],
          creation_date: "23 Dec",
          creation_time: "17:00",
          sub_data: [
            {
              title: "Second Call",
              status: "inqueue",
              due_date: "25 Nov",
              priority: "Highest",
              priority_class: "highest",
              linked_to: "Quotes-QT25",
              assignee: ["U", "R"],
              creation_date: "28 Dec",
              creation_time: "13:00",
            },
            {
              title: "Final Call",
              status: "completed",
              due_date: "20 Dec",
              priority: "Low",
              priority_class: "low",
              linked_to: "Quotes-QT28",
              assignee: ["U", "R"],
              creation_date: "20 Dec",
              creation_time: "15:00",
            },
            {
              title: "Follow Up",
              status: "inqueue",
              due_date: "31 Dec",
              priority: "Normal",
              priority_class: "normal",
              linked_to: "Quotes-QT24",
              assignee: ["U", "R"],
              creation_date: "26 Dec",
              creation_time: "19:00",
            },
          ],
        },
        {
          open_status: false,
          title: "Follow Up",
          status: "inqueue",
          due_date: "28 Dec",
          priority: "Low",
          priority_class: "low",
          linked_to: "Quotes-QT28",
          assignee: ["U", "R"],
          creation_date: "10 Dec",
          creation_time: "13:00",
          sub_data: [
            {
              title: "Second Call",
              status: "inqueue",
              due_date: "25 Nov",
              priority: "Highest",
              priority_class: "highest",
              linked_to: "Quotes-QT25",
              assignee: ["U", "R"],
              creation_date: "28 Dec",
              creation_time: "13:00",
            },
            {
              title: "Final Call",
              status: "completed",
              due_date: "20 Dec",
              priority: "Low",
              priority_class: "low",
              linked_to: "Quotes-QT28",
              assignee: ["U", "R"],
              creation_date: "20 Dec",
              creation_time: "15:00",
            },
            {
              title: "Follow Up",
              status: "inqueue",
              due_date: "31 Dec",
              priority: "Normal",
              priority_class: "normal",
              linked_to: "Quotes-QT24",
              assignee: ["U", "R"],
              creation_date: "26 Dec",
              creation_time: "19:00",
            },
          ],
        },
        {
          open_status: false,
          title: "Follow Up",
          status: "completed",
          due_date: "25 Dec",
          priority: "Highest",
          priority_class: "highest",
          linked_to: "Quotes-QT23",
          assignee: ["U", "R"],
          creation_date: "3 Dec",
          creation_time: "19:00",
          sub_data: [
            {
              title: "Second Call",
              status: "inqueue",
              due_date: "25 Nov",
              priority: "Highest",
              priority_class: "highest",
              linked_to: "Quotes-QT25",
              assignee: ["U", "R"],
              creation_date: "28 Dec",
              creation_time: "13:00",
            },
            {
              title: "Final Call",
              status: "completed",
              due_date: "20 Dec",
              priority: "Low",
              priority_class: "low",
              linked_to: "Quotes-QT28",
              assignee: ["U", "R"],
              creation_date: "20 Dec",
              creation_time: "15:00",
            },
            {
              title: "Follow Up",
              status: "inqueue",
              due_date: "31 Dec",
              priority: "Normal",
              priority_class: "normal",
              linked_to: "Quotes-QT24",
              assignee: ["U", "R"],
              creation_date: "26 Dec",
              creation_time: "19:00",
            },
          ],
        },
      ],
    },
  ]);
  const [warnTitle, setWarnTitle] = React.useState<boolean>(false);
  const [warnFirstName, setWarnFirstName] = React.useState<boolean>(false);
  const [warnLastName, setWarnLastName] = React.useState<boolean>(false);
  const [warnOrgName, setWarnOrgName] = React.useState<boolean>(false);
  const [warnPhone, setWarnPhone] = React.useState<boolean>(false);
  const [warnOrgEmail, setWarnOrgEmail] = React.useState<boolean>(false);
  const [viewTabsStatus, setViewTabsStatus] = React.useState("overview");
  const [openEmail, setOpenEmail] = React.useState(false);
  const [fullName, setFullName] = React.useState("Rahul Raghuvanshi");
  const [organizationName, setOrganizationName] = React.useState("Evervent");
  const [orgEmail, setOrgEmail] = React.useState("hello@evervent.in");
  const [personalemail, setPersonalEmail] = React.useState(
    "Kartike.kakkar@evervent.in"
  );
  const [notesData, setNotesData] = useState<
    Array<{ name: string; date: Date; description: string }>
  >([]);
  const [attachment, setAttachment] = React.useState(false);
  const [spoc, setSpoc] = React.useState("");
  const [phoneNumber, setPhoneNumber] = React.useState("0122-65456486");
  const [mobilenumber, setMobileNumber] = React.useState("8965455451");
  const [Currentjob, setCurrentJob] = React.useState("Asso. Developer");
  const [Currentemployer, setCurrentEmployer] = React.useState("Evervent");
  const [title, setTitle] = React.useState("Mr.");
  const [firstName, setFirstName] = React.useState("kartike");
  const [lastName, setLastName] = React.useState("kakkar");
  const [Department, setDepartment] = React.useState("FrontEnd");
  const [Designation, setDesignation] = React.useState(
    "Ass. Frontend Developer"
  );
  const [Dob, setDob] = React.useState<Date | null>(new Date());
  const [gender, setGender] = React.useState("Male");
  const [personalMobile, setPersonalMobile] = React.useState("9897854825");
  const [buildingName, setBuildingName] = React.useState("Next57,341,phase 9");
  const [areaName, setAreaName] = React.useState("Industrial Area");
  const [country, setCountry] = React.useState("India");
  const [email, setEmail] = React.useState("");
  const [State, setState] = React.useState("Punjab");
  const [StateOrg, setStateOrg] = React.useState("Punjab");
  const [City, setCity] = React.useState("Mohali");
  const [CityOrg, setCityOrg] = React.useState("Mohali");
  const [Zipcode, setZipcode] = React.useState("160062");
  const [ZipcodeOrg, setZipcodeOrg] = React.useState("160062");
  const [industry, setIndustry] = React.useState("I.T.");
  const [streetName, setStreetName] = React.useState("Gandhi Street");
  const [subindustry, setSubIndustry] = React.useState("Degsign");
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [removeStatus, setRemoveStatus] = React.useState(false);
  const [clientId, setClientId] = React.useState("EV1401");
  const [toggle, setToggle] = React.useState(true);
  const [uploadFile, setUploadFile] = React.useState(false);
  const [listViewStatus, setListViewStatus] = React.useState(true);
  const [expanded, setExpanded] = React.useState<string | false>("panel1");
  const [priorityStatus, setPriorityStatus] = React.useState("Pending");
  const [sectionStatus, SetSectionStatus] =
    React.useState<string>("personalDetails");
  const [subSection, setSubSection] = React.useState("businesscard");
  const [postQueryForm, setPostQueryForm] = React.useState(false);
  const title_data = [
    { key: "Mr.", value: "Mr." },
    { key: "Mrs.", value: "Mrs." },
    { key: "Ms.", value: "Ms." },
  ];
  const clientId_data = [
    { label: "EV101", value: "EV101" },
    { label: "EV120", value: "EV120" },
    { label: "EV201", value: "EV201" },
  ];
  const gender_data = [
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
  ];
  const disposition_table = [
    {
      sender_name: "Rahul Raghuvanshi",
      subject: "Automation Enhancements and ...",
      Cc_Bcc: "Umessh Gemini, Rohit Mankotia",
      Date_time: "30 Nov, 2022",
      time: "11:00 A.M.",
      attatchment: "",
    },
    {
      sender_name: "Rahul Raghuvanshi",
      subject: "Automation Enhancements and ...",
      Cc_Bcc: "Umessh Gemini, Kartike Kakkar",
      Date_time: "30 Nov, 2022",
      time: "11:00 A.M.",
      attatchment: "",
    },
  ];
  const industry_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const subindustry_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const ClientIds_data = [
    { label: "CL 0001", value: "CL 0001" },
    { label: "CL 0002", value: "CL 0002" },
    { label: "CL 0003", value: "CL 0003" },
    { label: "CL 0004", value: "CL 0004" },
    { label: "CL 0005", value: "CL 0005" },
    { label: "CL 0006", value: "CL 0006" },
  ];
  const attatchment_table_data = [
    {
      file_name: "621c94f41153e1835257b41b_lead mockup.webp",
      Date_time: "30 Nov, 2022",
      time: "11:00 A.M.",
    },
    {
      file_name: "621c94f41153e1835257b41b_lead mockup.webp",
      Date_time: "30 Nov, 2022",
      time: "11:00 A.M.",
    },
  ];
  const prioritystatusData = [
    { key: "Pending", value: "Pending" },
    { key: "Expired", value: "Expired" },
    { key: "Active", value: "Active" },
    { key: "Rejected", value: "Rejected" },
    { key: "Inprogress", value: "Inprogress" },
  ];
  const to_do_table_data = [
    {
      started_task: "Claim setterment follow up",
      due_date: "30 Nov,2022",
      priority_type: "Highest",
      linked_to: "Quotes",
      assignee: "",
      creation_time: "17:00 hrs",
      creation_date: "21-04-2011",
    },
    {
      started_task: "Claim setterment follow up",
      due_date: "30 Nov,2022",
      priority_type: "Highest",
      linked_to: "Quotes",
      assignee: "",
      creation_time: "17:00 hrs",
      creation_date: "21-04-2011",
    },
  ];
  const Department_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const country_data = [
    { label: "India", value: "India" },
    { label: "Australia", value: "Australia" },
    { label: "England", value: "England" },
    { label: "New Zealand", value: "New Zealand" },
    { label: " South Africa", value: "South Africa" },
  ];
  const Designation_data = [
    {
      label: "Associate Frontend Developer",
      value: "Associate Frontend Developer",
    },
    { label: "Frontend Developer", value: "Frontend Developer" },
    { label: "Senior Frontend Developer", value: "Senior Frontend Developer" },
    {
      label: "Associate Software Engineer",
      value: "Associate Software Engineer",
    },
    { label: "Software Engineer", value: "Software Engineer" },
    { label: "Associate Hr", value: "Associate Hr" },
    { label: "Hr Executive", value: "Hr Executive" },
  ];
  const state_data = [
    { label: "Rajasthan", value: "Rajasthan" },
    { label: "Punjab", value: "Punjab" },
    { label: "Haryana", value: "Haryana" },
    { label: "Kerla", value: "Kerla" },
    { label: "Delhi", value: "Delhi" },
  ];
  const city_data = [
    { label: "Ambala", value: "Ambala" },
    { label: "Nanital", value: "Nanital" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Jaipur", value: "Jaipur" },
    { label: " New Delhi", value: "New Delhi" },
  ];
  const ClientId_data = [
    { label: "CL 0001", value: "CL 0001" },
    { label: "CL 0002", value: "CL 0002" },
    { label: "CL 0003", value: "CL 0003" },
    { label: "CL 0004", value: "CL 0004" },
    { label: "CL 0005", value: "CL 0005" },
    { label: "CL 0006", value: "CL 0006" },
  ];
  const handleClicked = () => {
    setToggle(true);
  };
  const handleClick = () => {
    setToggle(false);
  };
  // const updateMasterState = (
  //   attrName: any,
  //   value: string | boolean | number
  // ) => {
  //   attrName(value);
  // };

  // for scrolling
  const personalDetails = useRef(null);
  const emaildetails = useRef(null);
  const attatchmentsdetails = useRef(null);
  const tododetails = useRef(null);
  //const ref = useRef(null);
  const businesscard = useRef(null);
  const professional = useRef(null);
  const personaladdress = useRef(null);

  const scrollToSection = (elementRef: any) => {
    // debugger;
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const updateMasterState = (attrName: any, value: any) => {
    if (attrName === "notes_new_data") {
      setNotesData((notesData) => [
        ...notesData,
        { name: "Umesh", date: new Date(), description: value },
      ]);
    } else {
      attrName(value);
    }
  };

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  return (
    <Box className="layoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate(-1);
            }}
          >
            <ChevronLeftIcon />
          </Link>
          <span className="detailIcon">A</span>
          <div>
            <h3>Ankit Sachdeva</h3>
            <p>CN0001 - Created on 12th Nov, 2022</p>
          </div>
        </Grid>
        <Grid
          xs={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          <div>
            <Tooltip title="Remove">
              <Link
                underline="none"
                className="actionLinks red_icon"
                onClick={() => {
                  setRemoveStatus(true);
                }}
              >
                <DeleteOutlineIcon />
              </Link>
            </Tooltip>
          </div>
          <div>
            <Tooltip title="Create Quote">
              <Link
                className="actionLinks"
                onClick={() => {
                  //navigate("/AddNewQuotess");
                }}
              >
                <PostAddIcon />
              </Link>
            </Tooltip>
          </div>
          <div>
            <Tooltip title="Global Edit">
              <Link
                className="actionLinks"
                onClick={() => {
                  navigate("/AddNewContact");
                }}
              >
                <BorderColorIcon />
              </Link>
            </Tooltip>
          </div>
          {/* Status Dropdown */}
          <div id={priorityStatus}>
            <div className="status_dropdown" id={priorityStatus}>
              {priorityStatus === "Highest" || priorityStatus === "Active" ? (
                <CheckCircleIcon id={priorityStatus} />
              ) : priorityStatus == "" || priorityStatus === "Rejected" ? (
                <CancelIcon id={priorityStatus} />
              ) : priorityStatus == "Pending" ? (
                <HourglassTopIcon id={priorityStatus} />
              ) : priorityStatus == "Inprogress" ? (
                <PublishedWithChangesIcon id={priorityStatus} />
              ) : priorityStatus == "Expired" ? (
                <HistoryToggleOffIcon id={priorityStatus} />
              ) : null}
              <SelectDropdown
                class_name="inputFieldd"
                title=""
                value={priorityStatus}
                attrName={setPriorityStatus}
                value_update={updateMasterState}
                dropdown_data={prioritystatusData}
                warn_status={false}
              />
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection h-100">
              <Link
                className={
                  sectionStatus === "personalDetails"
                    ? "active sectionLink personalDetails"
                    : "sectionLink personalDetails"
                }
                onClick={() => {
                  scrollToSection(personalDetails);
                  SetSectionStatus("personalDetails");
                }}
              >
                <span> Personal Details</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "businesscard"
                        ? "inner_link active businesscard"
                        : "inner_link businesscard"
                    }
                    onClick={() => {
                      setSubSection("businesscard");
                      handleClicks(subSection);
                      scrollToSection(businesscard);
                    }}
                  >
                    Business Card
                  </Link>
                </li>
                <li>
                  <Link
                    className={
                      subSection === "professional"
                        ? "inner_link active professional"
                        : "inner_link professional"
                    }
                    onClick={() => {
                      setSubSection("professional");
                      handleClicks(subSection);
                      scrollToSection(professional);
                    }}
                  >
                    Professional Details
                  </Link>
                </li>
                <li>
                  <Link
                    className={
                      subSection === "personaladdress"
                        ? "inner_link active personaladdress"
                        : "inner_link personaladdress"
                    }
                    onClick={() => {
                      setSubSection("personaladdress");
                      handleClicks(subSection);
                      scrollToSection(personaladdress);
                    }}
                  >
                    Personal Address
                  </Link>
                </li>
              </ul>
              {/* <Link
                className={
                  sectionStatus === "emaildetails"
                    ? "active sectionLink emaildetails"
                    : "sectionLink emaildetails"
                }
                onClick={() => {
                  scrollToSection(emaildetails);
                  SetSectionStatus("emaildetails");
                }}
              >
                <span>Emails</span>
              </Link> */}

              <Link
                className={
                  sectionStatus === "attatchmentsdetails"
                    ? "active sectionLink attatchmentsdetails"
                    : "sectionLink attatchmentsdetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(attatchmentsdetails);
                  SetSectionStatus("attatchmentsdetails");
                }}
              >
                <span>Attatchments</span>
              </Link>

              <Link
                className={
                  sectionStatus === "tododetails"
                    ? "active sectionLink tododetails"
                    : "sectionLink tododetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(tododetails);
                  SetSectionStatus("tododetails");
                }}
              >
                <span> Tasks</span>
              </Link>
            </Grid>
            <Grid xs className="rightSection h-100">
              <Grid container spacing={3} alignItems="center">
                <Grid lg={7} md={7} xs={12} className="pl-0">
                  <div className="productTabs ">
                    <Button
                      className={
                        viewTabsStatus == "overview"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "overview");
                      }}
                    >
                      Overview
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "company"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "company");
                      }}
                    >
                      Company
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "notes"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "notes");
                      }}
                    >
                      Notes
                    </Button>
                  </div>
                </Grid>
                <Grid
                  lg={5}
                  md={5}
                  xs={12}
                  style={{ textAlign: "right" }}
                  className="text-sm-center"
                >
                  <p className="lastupdate">
                    Last Update: 11:00AM, 10th Nov, 2022
                  </p>
                </Grid>
              </Grid>
              {viewTabsStatus == "overview" ? (
                <>
                  <Box className="detailSection" ref={personalDetails}>
                    <div className="sectionTitle">
                      <h4>Personal Details</h4>
                    </div>
                    <div ref={businesscard}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Business Card</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={4} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Full Name"
                            value={fullName}
                            attrName={setFullName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={8} lg={5}>
                          <RKTextField
                            class_name="inputField"
                            title="Organization"
                            value={organizationName}
                            attrName={setOrganizationName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={4} lg={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Mobile"
                            value={mobilenumber}
                            attrName={setMobileNumber}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={4} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Email"
                            value={personalemail}
                            attrName={setPersonalEmail}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={4} lg={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Office Phone"
                            value={phoneNumber}
                            attrName={setPhoneNumber}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={4} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Office Email"
                            value={orgEmail}
                            attrName={setOrgEmail}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid lg={3} md={4} xs={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Current Job Title"
                            value={Currentjob}
                            attrName={setCurrentJob}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid lg={3} md={4} xs={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Current Employer"
                            value={Currentemployer}
                            attrName={setCurrentEmployer}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                    <Grid container spacing={3}>
                      <Grid xs={12}>
                        <h5 className="subHeading">Basic Info</h5>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid xs={3} md={2} lg={2} xl={1}>
                        <SelectDropdown
                          class_name="inputField"
                          title="Title"
                          value={title}
                          attrName={setTitle}
                          value_update={updateMasterState}
                          dropdown_data={title_data}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={4} md={4} lg={3} xl={3}>
                        <RKTextField
                          class_name="inputField"
                          title={"First Name"}
                          value={firstName}
                          attrName={setFirstName}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={4} md={4} lg={3} xl={3}>
                        <RKTextField
                          class_name="inputField"
                          title={"Last Name"}
                          value={lastName}
                          attrName={setLastName}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid sm={4} md={4} lg={3} xl={2}>
                        <SelectDropdown
                          class_name="inputField"
                          title="Gender"
                          value={gender}
                          attrName={setGender}
                          value_update={updateMasterState}
                          dropdown_data={gender_data}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={4} md={4} lg={3} xl={2}>
                        <DatePicker
                          class_name="inputField"
                          title="Date of Birth"
                          value={Dob}
                          attrName={setDob}
                          value_update={updateMasterState}
                          error_message="Please enter Date of Birth"
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={4} md={4} lg={3} xl={2}>
                        <RKTextField
                          class_name="inputField"
                          title={"Mobile"}
                          value={mobilenumber}
                          attrName={setMobileNumber}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={4} md={4} lg={3} xl={2}>
                        <RKTextField
                          class_name="inputField"
                          title={"Email"}
                          value={email}
                          attrName={setEmail}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                    <div ref={professional}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Professional Details</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={6} md={4} lg={2}>
                          <RKTextField
                            class_name="inputField"
                            title={"Office Phone"}
                            value={phoneNumber}
                            attrName={setPhoneNumber}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={6} md={5} lg={3} xl={3}>
                          <RKTextField
                            class_name="inputField"
                            title={"Office Email"}
                            value={orgEmail}
                            attrName={setOrgEmail}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={6} md={5} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Department"
                            value={Department}
                            attrName={setDepartment}
                            value_update={updateMasterState}
                            data={Department_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid sm={6} md={5} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Designation"
                            value={Designation}
                            attrName={setDesignation}
                            value_update={updateMasterState}
                            data={Designation_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                      </Grid>
                    </div>
                    <div ref={personaladdress}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Personal Address</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={6} md={5} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Building/Street Name"
                            value={buildingName}
                            attrName={setBuildingName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={6} md={5} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Area Name"
                            value={areaName}
                            attrName={setAreaName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Country"
                            value={country}
                            attrName={setCountry}
                            value_update={updateMasterState}
                            data={country_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="State"
                            value={State}
                            attrName={setState}
                            value_update={updateMasterState}
                            data={state_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="City"
                            value={City}
                            attrName={setCity}
                            value_update={updateMasterState}
                            data={city_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <RKTextField
                            class_name="inputField"
                            title={"Zipcode"}
                            value={Zipcode}
                            attrName={setZipcode}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Box>
                  {/* we have hide this section for phase 2 */}
                  {/* <Box className="detailSection" ref={emaildetails}>
                    <div className="sectionTitle">
                      <h4>Emails </h4>
                      <div className="actionBtns">
                        <Link
                          className="redBtn delete"
                          sx={{ textDecoration: "none", cursor: "pointer" }}>
                          Delete
                        </Link>

                        <Link
                          className="blueBtn edit"
                          sx={{ textDecoration: "none", cursor: "pointer" }}>
                          Compose
                        </Link>
                      </div>
                    </div>

                    <Grid container spacing={3}>
                      <Grid xs={12}>                      
                        <div className="renewal-table">
                         <ul className="heading">
                            <li>From</li>
                            <li>Subject</li>
                            <li>Cc,Bcc</li>
                            <li>Date</li>
                            <li>Time</li>
                            <li>Attatchment</li>
                          </ul> 

                          {disposition_table.map((data, index) => (
                            <ul className="subheading">
                              <li>
                                <Link
                                  className="sender_name"
                                  onClick={() => {
                                    setOpenEmail(true);
                                  }}>
                                  {data.sender_name}
                                </Link>
                              </li>
                              <li>
                                <p className="subject"> {data.subject}</p>
                              </li>
                              <li>
                                Cc:
                                <span className="cc">{data.Cc_Bcc}</span>
                              </li>
                              <li>
                                <p className="date_time">{data.Date_time}</p>
                              </li>
                              <li>
                                <p className="time">{data.time}</p>
                              </li>
                              <li>
                                <Link className="attatchment">
                                  <Link >
                                    <img
                                      src="./images/attatch_icon.svg"
                                      alt=""
                                    />
                                  </Link>
                                  <Link >
                                    <img
                                      src="./images/share_icon.svg"
                                      alt=""
                                      className="ml-2"
                                    />
                                  </Link>
                                </Link>
                              </li>
                            </ul>
                          ))}
                        </div>
                      </Grid>
                    </Grid>
                  </Box> */}

                  <Box className="detailSection" ref={attatchmentsdetails}>
                    <div className="sectionTitle">
                      <h4>Attachments </h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => setUploadFile(true)}
                        >
                          Add Document
                        </Link>
                      </div>
                    </div>
                    <Attachment
                      open_status={attachment}
                      attrName={setAttachment}
                      value_update={updateMasterState}
                    />
                  </Box>
                  <Box className="detailSection" ref={tododetails}>
                    <div className="sectionTitle">
                      <h4>Tasks</h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Add Task
                        </Link>
                      </div>
                    </div>
                    <div className="mx-3">
                      <TasksSection />
                    </div>
                  </Box>
                </>
              ) : null}
              {viewTabsStatus == "company" ? (
                <>
                  <Box className="detailSection">
                    <div className="sectionTitle">
                      <h4>Organization Info</h4>
                    </div>
                    <Grid container spacing={3}>
                      <Grid xs={12} className="section_Heading">
                        <h5 className="subHeading">Organization Info</h5>
                      </Grid>
                    </Grid>
                    <Box className=" ml-3">
                      <Grid container spacing={3}>
                        <Grid xs={12} className="radio_group mt-3 mb-6">
                          <>
                            <RadioGroup row defaultValue="new">
                              <FormControlLabel
                                value="existing"
                                control={<Radio />}
                                label="Existing Client"
                                onClick={handleClick}
                              />
                              <FormControlLabel
                                // checked
                                value="new"
                                control={<Radio />}
                                label="New Client"
                                onClick={handleClicked}
                              />
                            </RadioGroup>
                          </>
                        </Grid>
                      </Grid>
                    </Box>
                    <Grid xs={12} style={{ padding: "0" }}>
                      {toggle == true ? (
                        <>
                          <Grid container spacing={3}>
                            <Grid sm={8} md={6} lg={6}>
                              <RKTextField
                                class_name="inputField"
                                title={"Organization"}
                                value={organizationName}
                                attrName={setOrganizationName}
                                value_update={updateMasterState}
                                warn_status={false}
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid sm={6} md={6} lg={6}>
                              <SearchDropdown
                                class_name="inputField"
                                title="Industry"
                                value={industry}
                                attrName={setIndustry}
                                value_update={updateMasterState}
                                data={industry_data}
                                warn_status={false}
                                error_message="Please select client"
                              />
                            </Grid>
                            <Grid sm={6} md={6} lg={6}>
                              <SearchDropdown
                                class_name="inputField"
                                title="Sub-Industry"
                                value={subindustry}
                                attrName={setSubIndustry}
                                value_update={updateMasterState}
                                data={subindustry_data}
                                warn_status={false}
                                error_message="Please select client"
                              />
                            </Grid>
                          </Grid>
                        </>
                      ) : null}
                    </Grid>
                    <Grid container spacing={3}>
                      {toggle == false ? (
                        <>
                          <Grid xs={12} md={6} lg={3}>
                            <SearchDropdown
                              class_name="inputField"
                              title="Search Client ID"
                              value={spoc}
                              attrName={setSpoc}
                              value_update={updateMasterState}
                              data={ClientIds_data}
                              warn_status={false}
                              error_message="Please select client"
                            />
                          </Grid>
                          {/* <Grid lg={12}>
                            <Grid container className="px-0 mb-4">
                              <Grid xs={4}>
                                <div className="existing_client_logo">
                                  <img
                                    src="./images/evervent-logo.svg"
                                    alt="digit"
                                    className="company_logo"
                                  />
                                </div>
                              </Grid>
                              <Grid xs={8}>
                                <p className="company_detail_heading">Company Name</p>
                                <p className="company_details">
                                  Evervent
                                  <span>Information Technology - Software</span>
                                </p>
                              </Grid>
                              <Grid xs={6} lg={4}>
                                <p className="company_detail_heading">
                                  Domain Name
                                </p>
                                <Link
                                  className="email_list"
                                  href="mailto:email@example.com">
                                  example@domain.com
                                </Link>
                              </Grid>
                              <Grid xs={6} lg={4}>
                                <p className="company_detail_heading">
                                  Website URL
                                </p>
                                <Link
                                  className="email_list"
                                  href=""
                                  target="_blank">
                                  www.example.com
                                </Link>
                              </Grid>

                              <Grid xs={6} lg={4}>
                                <p className="company_detail_heading">
                                  Contact Number
                                </p>
                                <p className="contactNumber">+91 9876543210</p>
                              </Grid>
                            </Grid>
                          </Grid> */}

                          <Grid xs={12} className="org-info mb-4">
                            <div className="logo-div">
                              <div className="existing_client_logo">
                                <img
                                  src="./images/evervent-logo.svg"
                                  alt="digit"
                                  className="company_logo"
                                />
                              </div>
                            </div>

                            <div className="info-details">
                              <Grid container>
                                <Grid xs={12}>
                                  <div className="inner-info-div">
                                    <p className="company-name">
                                      Evervent
                                      <span>
                                        Information Technology - Software
                                      </span>
                                    </p>
                                  </div>
                                </Grid>
                                <Grid xs={12} sx={{ display: "flex" }}>
                                  <div className="inner-info-div">
                                    <p className="info_p">
                                      Domain Name
                                      <span>
                                        <Link
                                          className="link"
                                          href="mailto:email@example.com"
                                        >
                                          example@domain.com
                                        </Link>
                                      </span>
                                    </p>
                                  </div>

                                  {/* <div className="inner-info-div">
                                    <p className="info_p">Website URL
                                      <span>
                                        <Link
                                        className="link"
                                        href="mailto:email@example.com">
                                        example@domain.com
                                      </Link>
                                      </span>
                                    </p>
                                  </div> */}

                                  <div className="inner-info-div">
                                    <p className="info_p">
                                      Contact Number
                                      <span>+91 9876543210</span>
                                    </p>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                          </Grid>
                        </>
                      ) : null}
                    </Grid>

                    <Grid container spacing={3}>
                      <Grid xs={12} className="section_Heading">
                        <h5 className="subHeading">Office Address</h5>
                      </Grid>
                      <Grid xs={4}>
                        <RKTextField
                          class_name="inputField"
                          title="Building/Street Name"
                          value={buildingName}
                          attrName={setBuildingName}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4}>
                        <RKTextField
                          class_name="inputField"
                          title="Area Name"
                          value={areaName}
                          attrName={setAreaName}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4}></Grid>
                      <Grid sm={6} md={4} lg={3} xl={3}>
                        <SearchDropdown
                          class_name="inputField"
                          title="Country"
                          value={country}
                          attrName={setCountry}
                          value_update={updateMasterState}
                          data={country_data}
                          warn_status={false}
                          error_message="Please select country."
                        />
                      </Grid>
                      <Grid sm={6} md={4} lg={3} xl={3}>
                        <SearchDropdown
                          class_name="inputField"
                          title="State"
                          value={State}
                          attrName={setState}
                          value_update={updateMasterState}
                          data={state_data}
                          warn_status={false}
                          error_message="Please select state"
                        />
                      </Grid>
                      <Grid sm={6} md={4} lg={3} xl={3}>
                        <SearchDropdown
                          class_name="inputField"
                          title="City"
                          value={City}
                          attrName={setCity}
                          value_update={updateMasterState}
                          data={city_data}
                          warn_status={false}
                          error_message="Please select city."
                        />
                      </Grid>
                      <Grid sm={6} md={4} lg={3} xl={3}>
                        <RKTextField
                          class_name="inputField"
                          title="Zipcode"
                          value={Zipcode}
                          attrName={setZipcode}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </>
              ) : null}
              {viewTabsStatus == "notes" ? (
                <>
                  <Box className="detailSection">
                    <div className="sectionTitle">
                      <h4>Notes</h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => {
                            setPostQueryForm(true);
                          }}
                        >
                          Add Notes
                        </Link>
                      </div>
                    </div>

                    <NotesSection data={notesData} />
                  </Box>
                </>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <SlidingPanel
        type={"right"}
        isOpen={openEmail}
        size={75}
        backdropClicked={() => setOpenEmail(false)}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={12}>
              <h4 className="mb-0 mt-4 ml-3">Emails</h4>
            </Grid>
            <Grid xs={12} className="mb-4">
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area">
            <div className="email_section">
              <Grid container spacing={2}>
                <Grid xs={6}>
                  <h6 className="person_name">Rahul Raghuvanshi</h6>
                  <p className="subjects">Automation Enhancements</p>
                  <p className="cc_bcc">
                    Cc: <span>Karan Joshi, Umemsh Gemini</span>
                  </p>
                </Grid>
                <Grid xs={6} sx={{ textAlign: "right" }}>
                  <p className="date_time">30 Nov, 2022 at 11:00 AM</p>
                  <Link className="attatchment_section">
                    <img src="./images/attatch_icon.svg" className="" alt="" />
                    <img src="./images/drop_down.svg" className="ml-4" alt="" />
                  </Link>
                </Grid>
                <Grid xs={12}>
                  <hr />
                </Grid>
                <Grid xs={12}>
                  <p className="mail_common">Hello Umesh,</p>
                  <p className="mail_data">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    <br />
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                  <p className="thanks">Thanks & Regards,</p>
                  <p className="mail_common">Munjal Patel</p>
                  <p className="mail_common">APM, EVERVENT</p>
                  <p className="mail_common">Mobile: +917719403800</p>
                  <p className="mail_common">Email: munjal.patel@evervent.in</p>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </SlidingPanel>
      <PostQueryForm
        attrName={setPostQueryForm}
        open_status={postQueryForm}
        value_update={updateMasterState}
      />
      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />

      <Modal open={deleteStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setDeleteStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are about to Delete this Attatchment.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <Modal open={removeStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setRemoveStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are want to remove this Contacts.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Box>
  );
}
export default ContactDetail;
